var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-statistic',{attrs:{"title":_vm.title,"value":_vm.defaultFormatter(_vm.value),"formatter":function (ref) {
	var value = ref.value;

	return this$1.$dict.humanReadable(value);
},"value-style":{ position: 'relative' }},scopedSlots:_vm._u([(_vm.value != undefined && _vm.previous != undefined)?{key:"suffix",fn:function(){return [_c('span',{staticClass:"statistic-suffix"},[_vm._v("环比"+_vm._s(_vm.chainGrowth(_vm.previous, _vm.value))+"%"),_c('a-icon',{style:({color: _vm.value > 0 ? 'red' : 'chartreuse'}),attrs:{"type":_vm.value > 0 ? 'arrow-up' : 'arrow-down'}})],1)]},proxy:true}:null],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }